export default __webpack_public_path__ + "static/media/84_mobile.909cb41f.jpg";